module.exports = __webpack_public_path__ + "static/vitoseji-8d26d0ed52a93a646841cff72b358c39.jpg";